// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
export const resetSelectedProgram = () => (dispatch, getState) => {

    const {allowedPrograms, selectedProgram} = getState().claims.incentive.claim;

    const isReset = allowedPrograms.find(option => option.programName === selectedProgram.programName);

    if (typeof isReset === 'undefined') {

        dispatch({
            type: actions.RESET_CLAIM_INCENTIVE_SELECTED_PROGRAM
        });

    }

};



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/reset-selected-program.js